import styled from '@emotion/styled';
const Card = styled.article `
  border: ${({ theme }) => theme.borderWidth[25]} solid ${({ theme }) => theme.color.border.base};
  padding: ${({ theme }) => theme.spacing[600]};
  width: 100%;

  ${({ isDrawer, theme }) => isDrawer
    ? {
        border: 'none',
        borderBottom: `${theme.borderWidth[25]} solid ${theme.color.border.base}`,
        padding: `${theme.spacing[600]} 0`,
    }
    : {
        borderRadius: theme.borderRadius[100],
    }}
`;
export { Card };
//# sourceMappingURL=styled.js.map